import { render } from "./RiepilogoMensileRid.vue?vue&type=template&id=92e6b686"
import script from "./RiepilogoMensileRid.vue?vue&type=script&lang=js"
export * from "./RiepilogoMensileRid.vue?vue&type=script&lang=js"

import "./RiepilogoMensileRid.vue?vue&type=style&index=0&id=92e6b686&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__